module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"other":"Otro"},"en":{"other":"Other"}}')
  delete Component.options._Ctor
}
